import { alpha, makeStyles, Theme } from '@material-ui/core/styles';

const FOLLOW_UP_ALPHA = 0.1;

export const useWorkingLeadCardStyles = makeStyles((theme: Theme) => ({
    link: { display: 'block', textDecoration: 'none' },
    card: {
        padding: theme.spacing(1.5),
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&:hover': {
            borderColor: theme.palette.primary.main,
            boxShadow: theme.shadows[2],
        },
    },
    top: { alignItems: 'center', display: 'flex', gap: theme.spacing(1) },
    avatar: {
        background: `linear-gradient(135deg, ${theme.palette.primary.light}, ${theme.palette.secondary.main})`,
        fontSize: theme.typography.caption.fontSize,
        height: 26,
        width: 26,
    },
    name: { flex: '1 1 auto' },
    rating: { color: theme.palette.common.white, maxWidth: 80 },
    followUp: {
        alignItems: 'center',
        backgroundColor: alpha(theme.palette.primary.main, FOLLOW_UP_ALPHA),
        borderRadius: theme.shape.borderRadius,
        color: theme.palette.primary.main,
        display: 'flex',
        gap: theme.spacing(0.75),
        marginTop: theme.spacing(1),
        padding: theme.spacing(0.75, 1),
    },
    overdue: {
        backgroundColor: alpha(theme.palette.error.main, FOLLOW_UP_ALPHA),
        color: theme.palette.error.main,
    },
    empty: {
        backgroundColor: theme.palette.action.hover,
        color: theme.palette.text.secondary,
    },
    footer: {
        alignItems: 'center',
        borderTop: `1px solid ${theme.palette.divider}`,
        color: theme.palette.text.disabled,
        display: 'flex',
        gap: theme.spacing(1),
        marginTop: theme.spacing(1),
        paddingTop: theme.spacing(1),
    },
    active: { color: theme.palette.primary.main },
    activity: {
        alignItems: 'center',
        display: 'flex',
        gap: theme.spacing(0.5),
        marginLeft: 'auto',
    },
}));
